import { Div, SubnavigationButton, Button, FixedLayout, SubnavigationBar } from '@vkontakte/vkui';
import PropTypes from 'prop-types';
import React from 'react';
import { ScanReceiptButtonComponent } from './ScanReceiptButtonComponent';

export const AddPaymentButtonsComponent = ({onCreatePayment, addPaymentLabel, isReceiptScanner, scanReceiptLabel, event}) => {
  if (isReceiptScanner) {
    return (<FixedLayout filled={true} vertical="bottom" style={{textAlign: 'center', }}>
      <SubnavigationBar mode="fixed">
        <ScanReceiptButtonComponent
          label={scanReceiptLabel}
          event={event}
        />
        <SubnavigationButton
          size="m"
          textLevel={'1'}
          selected={true}
          onClick={() => onCreatePayment()}
        >
          {addPaymentLabel}
        </SubnavigationButton>
      </SubnavigationBar>
    </FixedLayout>);
  }

  return (
    <FixedLayout filled={true} vertical="bottom" style={{textAlign: 'center'}}>
      <Div>
        <Button
          size="l"
          selected={true}
          stretched={true}
          onClick={() => onCreatePayment()}
        >
          {addPaymentLabel}
        </Button>
      </Div>
    </FixedLayout>
  );
}

AddPaymentButtonsComponent.propTypes = {
  onCreatePayment: PropTypes.func.isRequired,
  addPaymentLabel: PropTypes.string.isRequired,
  isReceiptScanner: PropTypes.bool.isRequired,
  scanReceiptLabel: PropTypes.string.isRequired,
};
